// extracted by mini-css-extract-plugin
export var carousel = "Y9RRs";
export var contentCol = "crpFI";
export var ctaContainer = "rdIsw";
export var sectionBg = "Rg-Xw";
export var sectionImage = "T15QD";
export var sectionImageContainer = "cImqy";
export var title = "IsGff";
export var uspSectionList = "cZQ-t";